// extracted by mini-css-extract-plugin
export default {"thumbnail":"AddToCart-module__thumbnail--D6tf"};